<dt class="c:copy fs:xs m-8:b">
    {{ heading }}:
    @if (tooltipText) {
        <app-info-tooltip [text]="tooltipText"></app-info-tooltip>
    }
</dt>
<dd
    class="fs:s fw:semibold c:copy test"
    [class.c:blue-700]="isImportant"
>
    @if (icon) {
        <i
            [ctrlIcon]="icon"
            [class]="iconClass"
        ></i>
    }
    {{ detail }}
</dd>
